<template>
  <div id="app">
    <div v-if="deviceready">

      <!-- ポップアップ -->
      <ModalDialog v-show="$store.state.showModalDialog">
      </ModalDialog>

      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deviceready: false
    };
  },
  created() {
    // this.swipe_back();

    gtag('event', 'page_view', {
      'event_category' : 'src',
      'event_label' : 'App'
    });

    // クリック遅延をなくす
    if ("addEventListener" in document) {
      document.addEventListener(
        "DOMContentLoaded",
        function() {
          FastClick.attach(document.body);
        },
        false
      );
    }

    // なぜかdevicereadyが発火しないので代わり
    window.setTimeout(() => {
      this.deviceready = true;
    }, 1000);

    /* ピッチインピッチアウトによる拡大縮小を禁止 */
    document.documentElement.addEventListener(
      "touchstart",
      function(e) {
        if (e.touches.length >= 2) {
          e.preventDefault();
        }
      },
      { passive: false }
    );
    console.log("[App]初期化");
    // 初期化
    console.log(
      "this.$store.state.hands_history.length: " +
        this.$store.state.hands_history.length
    );
    if (this.$store.state.hands_history.length == 0) {
      this.$store.dispatch("clear_all");
    }
    console.log(
      "this.$store.state.now_hands: " +
        JSON.stringify(this.$store.state.now_hands)
    );
    if (this.$store.state.now_hands.length == 0) {
      this.$store.dispatch("clear_all");
    }
    if (this.$store.state.memo_list.length == 0) {
      this.$store.commit("initialize_memo_list");
    }
  },
  methods: {
    onDeviceReady() {
      this.deviceready = true;
    },
    // スワイプで前画面に戻る
    swipe_back() {
      const self = this;
      window.addEventListener(
        "load",
        function(event) {
          var touchStartX;
          var touchStartY;
          var touchMoveX;
          var touchMoveY;

          // 開始時
          window.addEventListener(
            "touchstart",
            function(event) {
              event.stopPropagation();
              // 座標の取得
              touchStartX = event.touches[0].pageX;
              touchStartY = event.touches[0].pageY;
            },
            { passive: false }
          );

          // 移動時
          window.addEventListener(
            "touchmove",
            function(event) {
              event.stopPropagation();
              // 座標の取得
              touchMoveX = event.changedTouches[0].pageX;
              touchMoveY = event.changedTouches[0].pageY;
            },
            { passive: false }
          );

          // 終了時
          window.addEventListener(
            "touchend",
            function(event) {
              event.stopPropagation();
              // 移動量の判定
              if (touchStartX > touchMoveX) {
                if (touchStartX > touchMoveX + 100) {
                  console.log("右から左に指が移動した場合");
                }
              } else if (touchStartX < touchMoveX) {
                if (touchStartX + 100 < touchMoveX) {
                  console.log("左から右に指が移動した場合");
                  if (self.$router.currentRoute.name != "Home") {
                    self.$router.go("-1");
                  }
                }
              }
            },
            { passive: false }
          );
        },
        false
      );
    }
  }
};
</script>
<style lang="scss">
// 要素を選択不可にする
* {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
html {
  background-color: black;
  overflow: hidden;
}
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  border: none;
  overflow: hidden;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  height: 100vh;
  width: 100vw;
}
</style>
